import DuoTone from "./duoTone";
import Regular from "./regular";
import Solid from "./solid";
import Light from "./light";
import Brands from "./brands";

export { DuoTone, Regular, Solid, Light, Brands };



// WEBPACK FOOTER //
// ./src/fontawesome/index.js